import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipantBehaviour } from '../mutations/deleteParticipantBehaviour.mutation';
import type {
  DeleteParticipantBehaviourMutation,
  DeleteParticipantBehaviourMutationVariables,
} from '../types';

export const useDeleteParticipantBehaviourMutation = (
  options?: MutationOptions<
    DeleteParticipantBehaviourMutation,
    DeleteParticipantBehaviourMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantBehaviour), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
